<template>
  <div>...</div>
</template>

<script>
  export default {
    name: 'MerchantKey',
    beforeCreate() {
      const token = localStorage.getItem('token')
      const userDataCache = localStorage.getItem('userData')
      const userData = userDataCache ? JSON.parse(userDataCache) : {}

      const location = window.location
      const currentDomain = location.host
      const currentPath = location.pathname

      const mapDomain = {
        'localhost:8080': 'http://localhost:4000',
        'crm-mynextpay.nextshop.dev': 'https://dev-cskh-mynextpay.nextpay.vn',
        'my.nextpay.global': 'https://cskh-mynextpay.nextpay.vn',
        'my.nextpay.vn': 'https://cskh-mynextpay.nextpay.vn',
        'crm.nextpay.global': 'https://cskh-mynextpay.nextpay.vn',
      }

      window.location.href = `${mapDomain[currentDomain]}${currentPath}/?from=${location.origin}&token=${token}&username=${userData.username}&name=${userData.name}`
    },
  }
</script>
